// Main entry point for the game
// Import all TypeScript files in dependency order
import './Vector'
import './Matrix'
import './Plane'
import './GameObject'
import './Physics'
import './Collision'
import './Timing'
import { start } from './Dynamics'

console.log('main.ts loaded, start function:', start);

// Export the game namespace for use in HTML
declare global {
  interface Window {
    startGame: typeof start
  }
}

// Make start function available globally
window.startGame = start
console.log('window.startGame set to:', window.startGame);
